function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("clipPath", {
  id: "image-mask-small-mirror",
  clipPathUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1,0.112 C1,0.102,1,0.093,0.992,0.092 L0.018,0.002 C0.01,0.001,0.003,0.01,0.004,0.021 L0.093,0.986 C0.094,0.996,0.101,1,0.107,1 L0.929,0.889 C0.935,0.888,0.94,0.882,0.94,0.873 L1,0.112"
}));

var SvgImageMaskSmallMirror = function SvgImageMaskSmallMirror(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImageMaskSmallMirror, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/image-mask-small-mirror.45280905.svg";
export { ForwardRef as ReactComponent };